export default __webpack_public_path__ + "static/media/anexoGreen.f6a80cb2.svg";